import { useCallback, useEffect, useRef } from "react";
import { Actions, JobState } from "../types";

const CHECKOUT_REFRESH_INTERVAL = 60; // check out the job every minute

export const useKeepJobCheckedOut = (jobState: JobState, checkout: Actions["refreshCheckout"]) => {
  const timeoutIdRef = useRef<NodeJS.Timeout>();
  const cancel = useCallback(() => {
    const timeoutId = timeoutIdRef.current;
    if (timeoutId) {
      timeoutIdRef.current = undefined;
      clearTimeout(timeoutId);
    }
  }, [timeoutIdRef]);

  useEffect(() => {
    if (jobState === JobState.ready) {
      timeoutIdRef.current = setInterval(checkout, CHECKOUT_REFRESH_INTERVAL * 1000);
    } else if (timeoutIdRef.current) {
      cancel();
    }
    return cancel;
  }, [cancel, checkout, jobState]);
};
